import { render, staticRenderFns } from "./DemandarForm.vue?vue&type=template&id=29ab11d4&scoped=true"
import script from "./DemandarForm.vue?vue&type=script&lang=ts"
export * from "./DemandarForm.vue?vue&type=script&lang=ts"
import style0 from "./DemandarForm.vue?vue&type=style&index=0&id=29ab11d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ab11d4",
  null
  
)

export default component.exports